import { Service } from '@roc/feature-app-core';
import { BulkImportRow, SetFinancingAmountRequest } from '../utils/debtTrackingConstants';

// Debt tracking endpoints of assetm-service (roc-services), routed by the gateway. Responses are ApiResponse { status, data };
// list endpoints return PaginatedResponse { totalCount, rows } as expected by GridStore.
const BASE_URL = '/api/v1/assetm/debt-tracking';

const url = {
  WAREHOUSES: `${BASE_URL}/warehouses`,
  WAREHOUSE_SUMMARY: (warehouseId: number) => `${BASE_URL}/warehouses/${warehouseId}/summary`,
  WAREHOUSE_LOANS: (warehouseId: number) => `${BASE_URL}/warehouses/${warehouseId}/loans`,
  LOAN_DETAIL: (loanId: string) => `${BASE_URL}/loans/${loanId}`,
  LOAN_HISTORY: (loanId: string) => `${BASE_URL}/loans/${loanId}/history`,
  FINANCING_AMOUNTS: `${BASE_URL}/financing-amounts`,
  BULK_IMPORT_PREVIEW: `${BASE_URL}/bulkImport/preview`,
  BULK_IMPORT: `${BASE_URL}/bulkImport`,
};

export interface GridPageParams {
  page: number;
  pageSize: number;
  sortBy?: string;
  sortDir?: string;
  filters?: Record<string, string>;
  dropdownFilters?: Record<string, string>;
}

export class DebtTrackingService extends Service {

  getWarehouses() {
    return this.get(url.WAREHOUSES);
  }

  getWarehouseSummary(warehouseId: number) {
    return this.get(url.WAREHOUSE_SUMMARY(warehouseId), {}, { disableGlobalLoading: true });
  }

  getWarehouseLoans(warehouseId: number, search: string, params: GridPageParams) {
    return this.get(url.WAREHOUSE_LOANS(warehouseId), { search: search || undefined, ...params }, { disableGlobalLoading: true });
  }

  getLoanDebtDetail(loanId: string) {
    return this.get(url.LOAN_DETAIL(loanId));
  }

  // Every value the loan's financing amount had, newest first.
  getLoanHistory(loanId: string) {
    return this.get(url.LOAN_HISTORY(loanId), {}, { disableGlobalLoading: true });
  }

  // Replaces the financing amount of one or many loans (new loan IDs are created).
  setFinancingAmount(request: SetFinancingAmountRequest) {
    return this.post(url.FINANCING_AMOUNTS, request);
  }

  previewBulkImport(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.post(url.BULK_IMPORT_PREVIEW, formData);
  }

  applyBulkImport(rows: BulkImportRow[]) {
    return this.post(url.BULK_IMPORT, { rows });
  }
}
